/* Landing-page fit filters, image controls and accessible design-story tabs. */
(() => {
  if (!document.querySelector('.yv-home')) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const canAnimate = () => !reducedMotion.matches;
  const fadeIn = element => window.YVMotion?.reveal(element);

  // Keep fit selection beside real products; full collection links work without JavaScript.
  const products = document.querySelector('[data-home-products]');
  if (products) {
    const buttons = [...products.querySelectorAll('[data-fit-filter]')];
    const cards = [...products.querySelectorAll('[data-home-fit]')];
    const viewAll = products.querySelector('[data-fit-view-all]');
    const status = products.querySelector('[data-fit-status]');
    const chooseFit = button => {
      const fit = button.dataset.fitFilter;
      buttons.forEach(control => control.setAttribute('aria-pressed', String(control === button)));
      let visible = 0;
      cards.forEach(card => {
        card.hidden = fit === 'all' ? card.dataset.homeFeatured !== 'true' : card.dataset.homeFit !== fit;
        if (!card.hidden) visible++;
      });
      viewAll.href = viewAll.dataset[`${fit}Url`];
      viewAll.querySelector('[data-fit-view-label]').textContent = viewAll.dataset[`${fit}Label`];
      status.textContent = `Showing ${visible} ${fit === 'all' ? 'featured' : fit + ' fit'} designs.`;
    };
    buttons.forEach(button => button.addEventListener('click', () => chooseFit(button)));
    products.querySelector('[data-fit-filters]').hidden = false;
  }

  // Front/back buttons and swipe share one crossfade and one selected state.
  const hero = document.querySelector('[data-hero-gallery]');
  if (hero) {
    const controls = [...hero.querySelectorAll('[data-hero-view]')];
    const photos = [...hero.querySelectorAll('[data-hero-photo]')];
    controls.forEach(button => {
      button.setAttribute('aria-label', `Show ${button.textContent.toLowerCase()} view`);
      button.innerHTML = '<span class="yv-photo-pip" aria-hidden="true"></span>';
    });
    const slider = new window.YVSwipeRail(hero.querySelector('.hero-images'), {items: photos,
      onChange: index => {
        const view = photos[index].dataset.heroPhoto;
        controls.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        window.YVFadeCaption(hero.querySelector('[data-hero-view-label]'), view.toUpperCase());
        hero.querySelector('[data-hero-status]').textContent = `${view === 'front' ? 'Front' : 'Back'} view`;
      }
    });
    hero.querySelector('.hero-images').addEventListener('yv:fade-progress', event => {
      controls.forEach((button, i) => button.querySelector('.yv-photo-pip').style.setProperty('--photo-weight', event.detail.weights[i] || 0));
    });
    controls.forEach((button, index) => {
      button.addEventListener('click', () => slider.go(index));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? controls.length - 1
          : (index + (event.key === 'ArrowRight' ? 1 : -1) + controls.length) % controls.length;
        controls[next].focus(); slider.go(next);
      });
    });
  }

  // ARIA tabs retain a single keyboard tab stop and expose a named, real product link.
  const tabs = [...document.querySelectorAll('[data-philosophy]')];
  const panels = [...document.querySelectorAll('.philosophy-panel')];
  const choosePhilosophy = (tab) => {
    const wasSelected = tab.getAttribute('aria-selected') === 'true';
    tabs.forEach(button => {
      button.setAttribute('aria-selected', String(button === tab));
      button.tabIndex = button === tab ? 0 : -1;
    });
    const selectedPanel = document.getElementById(tab.getAttribute('aria-controls'));
    panels.forEach(panel => { panel.hidden = panel !== selectedPanel; });
    const image = selectedPanel.querySelector('img');
    image.loading = 'eager';
    if (!wasSelected) fadeIn(selectedPanel);
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => choosePhilosophy(tab));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
        : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[next].focus();
      choosePhilosophy(tabs[next]);
    });
  });

  // Content is visible without the observer. Each story note animates once in natural scroll.
  if (canAnimate() && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (!canAnimate()) return;
        if (entry.target.hasAttribute('data-gold-line')) {
          entry.target.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}], {
            duration:900, easing:'cubic-bezier(.22,1,.36,1)'
          });
        } else fadeIn(entry.target);
      });
    }, {threshold: .2});
    document.querySelectorAll('[data-story-reveal],[data-gold-line]').forEach(element => observer.observe(element));
  }
  reducedMotion.addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('[data-hero-photo],.philosophy-panel,[data-story-reveal],[data-gold-line]')
      .forEach(element => element.getAnimations().forEach(animation => animation.cancel()));
  });
})();
